// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationGuid_container__1FxMK","back_btn":"ApplicationGuid_back_btn__2HJIg","title":"ApplicationGuid_title__3bAbP","red_color":"ApplicationGuid_red_color__1M_Tj"};